import OrbitAvatar from '@/components/OrbitAvatar'
import {
  currencyUnitOptions,
  editTask,
  editTaskDate,
  priorityOptions,
  statusOptions,
  workingUnitOptions
} from '@/services/task/task'
import { DatePicker, Form, InputNumber, Select, Space } from 'antd'
import dayjs from 'dayjs'
import { memo, useEffect } from 'react'
import styles from './index.module.less'

const DetailForm = memo((props: any) => {
  const { task, members, updateTask } = props
  const [form] = Form.useForm()

  useEffect(() => {
    if (task) {
      form.setFieldsValue({
        ...task,
        startDate: dayjs(task.startDate),
        endDate: dayjs(task.endDate),
        assignees: task.assignees[0]?.memberId,
        completionRate: task.completionRate * 100
      })
    }
  }, [task])

  const handleChange = async (key, value) => {
    const reqData = {}
    switch (key) {
      case 'assignees':
        reqData[key] = [value]
        break
      case 'completionRate':
        if (value >= 100) {
          reqData[key] = 100
        }
        if (value <= 0) {
          reqData[key] = 0
        }
        reqData[key] = value / 100
        break
      default:
        reqData[key] = value
    }

    const data = await editTask(task.id, reqData)
    updateTask(data)
  }

  const handleDateChange = async (key, value) => {
    const data = await editTaskDate(task.id, { [key]: value.valueOf() })
    updateTask(data)
  }

  return (
    <div className={styles.form}>
      <Form form={form} layout='vertical'>
        <Form.Item name='assignees' label='Assignees'>
          <Select
            onChange={(value) => {
              handleChange('assignees', value)
            }}
          >
            {members.map((member) => (
              <Select.Option key={member.memberId} value={member.memberId}>
                <Space>
                  <OrbitAvatar size={24} avatar={member.avatar} name={member.fullName} />
                  {member.fullName}
                </Space>
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name='priority' label='Priority'>
          <Select
            onChange={(value) => {
              handleChange('priority', value)
            }}
          >
            {priorityOptions.map((item) => (
              <Select.Option value={item.value} key={item.value}>
                {item.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name='status' label='Status'>
          <Select
            onChange={(value) => {
              handleChange('status', value)
            }}
          >
            {statusOptions.map((item) => (
              <Select.Option value={item.value} key={item.value}>
                {item.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name='startDate' label='Start'>
          <DatePicker
            className='w100'
            onChange={(value) => {
              handleDateChange('startDate', value)
            }}
          />
        </Form.Item>

        <Form.Item name='endDate' label='Finish'>
          <DatePicker
            className='w100'
            onChange={(value) => {
              handleDateChange('endDate', value)
            }}
          />
        </Form.Item>

        <Form.Item name='completionRate' label='Completion Rate'>
          <InputNumber
            className='w100'
            addonAfter='%'
            onBlur={(e) => {
              handleChange('completionRate', e.target.value)
            }}
          />
        </Form.Item>

        <Form.Item name='timeSpent' label='Estimated working hours'>
          <InputNumber
            className='w100'
            onBlur={(e) => {
              handleChange('timeSpent', e.target.value)
            }}
            addonAfter={
              <Form.Item noStyle name='timeUnit' initialValue={1}>
                <Select
                  style={{ minWidth: '80px' }}
                  onChange={(value) => {
                    handleChange('timeUnit', value)
                  }}
                >
                  {workingUnitOptions.map((item) => (
                    <Select.Option value={item.value} key={item.value}>
                      {item.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            }
          />
        </Form.Item>

        <Form.Item name='moneySpent' label='Estimated Spent'>
          <InputNumber
            className='w100'
            onBlur={(e) => {
              handleChange('moneySpent', e.target.value)
            }}
            addonAfter={
              <Form.Item noStyle name='monetaryBudgetCurrency' initialValue={1}>
                <Select
                  style={{ minWidth: '80px' }}
                  onChange={(value) => {
                    handleChange('monetaryBudgetCurrency', value)
                  }}
                >
                  {currencyUnitOptions.map((item) => (
                    <Select.Option value={item.value} key={item.value}>
                      {item.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            }
          />
        </Form.Item>
      </Form>
    </div>
  )
})

export default DetailForm
